import React from 'react';
import { motion } from 'framer-motion';
import { FiMaximize2, FiMapPin, FiLayers, FiInfo } from 'react-icons/fi';

export default function GiantImperial({ data, color }) {
    // 🛡️ BLINDAGEM DE DADOS: Suporta tanto o Mock quanto o Schema do Banco
    const title = data?.titulo || data?.title || 'Ativo sem Título';
    const location = data?.bairro || data?.location || 'Localização sob consulta';
    const city = data?.cidade || '';
    
    // Formatação de Preço Elite
    const price = data?.preco || data?.price;
    const formattedPrice = typeof price === 'number' 
        ? price.toLocaleString('pt-BR', { style: 'currency', currency: 'BRL' })
        : price || 'Consulte';

    // Imagem com Fallback
    const mainImage = data?.imagensDestaque?.[0] || data?.image || 'https://images.unsplash.com/photo-1600607687920-4e2a09cf159d';

    return (
        <motion.div 
            initial={{ opacity: 0, y: 20 }} 
            animate={{ opacity: 1, y: 0 }} 
            className="relative w-full h-[700px] rounded-[4rem] overflow-hidden group border border-[var(--border-color)] shadow-2xl"
            style={{ backgroundColor: 'var(--bg-card)' }}
        >
            {/* 🎥 BACKGROUND CINEMATIC */}
            <img 
                src={mainImage} 
                alt={title}
                className="absolute inset-0 w-full h-full object-cover transition-transform duration-[2s] ease-out group-hover:scale-110 group-hover:rotate-1" 
            />
            
            {/* 🎭 OVERLAY DE GRADIENTE (Foco no Texto) */}
            <div className="absolute inset-0 bg-gradient-to-t from-[var(--bg-main)] via-black/20 to-transparent opacity-90" />
            
            {/* 🏷️ TAGS SUPERIORES */}
            <div className="absolute top-12 left-12 flex gap-4">
                <span className="px-6 py-2 rounded-full bg-white/10 backdrop-blur-xl border border-white/20 text-[9px] font-black uppercase tracking-[0.4em] text-white">
                    {data?.tipoPrincipal || 'Imóvel Gold'}
                </span>
                {data?.isDestaque && (
                    <span className="px-6 py-2 rounded-full bg-[var(--accent-color)] text-black text-[9px] font-black uppercase tracking-[0.4em] animate-pulse">
                        Destaque Sniper
                    </span>
                )}
            </div>

            {/* 📊 CONTEÚDO INFERIOR */}
            <div className="absolute bottom-16 left-16 right-16 flex justify-between items-end">
                <div className="max-w-2xl space-y-6">
                    <div className="flex items-center gap-3 text-[var(--accent-color)] mb-2">
                        <FiLayers size={20} />
                        <span className="text-[10px] font-black uppercase tracking-[0.5em]">Patrimônio de Luxo</span>
                    </div>
                    
                    <h2 className="text-7xl font-black text-white uppercase tracking-tighter leading-[0.85] drop-shadow-2xl">
                        {title}
                    </h2>
                    
                    <p className="flex items-center gap-3 text-white/70 font-bold uppercase text-[11px] tracking-[0.3em]">
                        <FiMapPin className="text-[var(--accent-color)]" size={18} />
                        {location} {city && `// ${city}`}
                    </p>
                </div>

                <div className="flex flex-col items-end gap-6">
                    <div className="text-right">
                        <span className="block text-[10px] font-black uppercase opacity-50 text-white tracking-[0.4em] mb-1">Valor do Ativo</span>
                        <div className="text-5xl font-black text-white drop-shadow-lg" style={{ color: 'var(--accent-color)' }}>
                            {formattedPrice}
                        </div>
                    </div>

                    <button 
                        className="group/btn relative px-12 py-6 overflow-hidden rounded-2xl bg-white text-black font-black uppercase text-[10px] tracking-[0.4em] transition-all hover:scale-105 active:scale-95 shadow-2xl"
                    >
                        <span className="relative z-10 flex items-center gap-4">
                            Inspecionar Dossiê <FiMaximize2 />
                        </span>
                        <div className="absolute inset-0 bg-[var(--accent-color)] translate-y-full group-hover/btn:translate-y-0 transition-transform duration-300" />
                    </button>
                </div>
            </div>

            {/* 📐 INDICADOR DE ZOOM (MOS-ZOOM) */}
            <div className="absolute bottom-6 left-1/2 -translate-x-1/2 opacity-20">
                <p className="text-[8px] font-black uppercase tracking-[1em] text-white">MOS ENGINE // PROTOCOL IMPERIAL</p>
            </div>
        </motion.div>
    );
}